import { Col, Grid, Loader, Row } from 'rsuite';
import { useState } from 'react';
import { InstanceActions } from './InstanceActions';
import { InstanceAction, server } from '../../config/const';
import InstanceInfo from './InstanceInfo';

interface IProps {
  rowData: Record<string, any>;
}

const Instance = ({ rowData }: IProps) => {
  return (
    <>
      <Grid fluid className="instance-content">
        <Row className="show-grid instance-content-row" gutter={0}>
          <Col xs={24} className="instance-content-col">
            <div
              className="instance-content-container"
              style={{
                marginLeft: '10px'
              }}
            >
              <InstanceInfo rowData={rowData} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={24} className="instance-content-controller">
            <InstanceActions
              rowData={rowData}
              server={server}
              actionConst={InstanceAction}
            />
          </Col>
        </Row>
      </Grid>
    </>
  );
};

export default Instance;
